import React, { Component } from "react";

export default class TicketsCell extends Component {
  onCheckChange = (e) => {
    this.props.toggleSelection(this.props.ticket);
  };

  deleteCallback = () => {
    this.props.removeFromSelected(this.props.ticket);
  };

  render() {
    var { ticketname, currency, price } = this.props.ticket;
    var { checked, selectedtickets } = this.props;
    var style = { fontSize: 10, overflowWrap: "break-word", color: "#4da1ff" };

    return selectedtickets === false ? (
      <tr>
        <td style={{ width: "10%", textAlign: "center" }}>
          <label className="checkcontainer">
            <input
              type="checkbox"
              onChange={this.onCheckChange}
              checked={checked}
            />
            <span className="checkcheckmark" />
          </label>
        </td>

        <td>
          <div>{ticketname}</div>
          <span style={style}>
            {price > 0 ? currency + " " + price : "FREE"}
          </span>
        </td>
        {/* <td>{email}</td> */}
      </tr>
    ) : (
      <tr>
        <td>
          <div className="vertical-align-center-justify-between">
            <div>
              <div>{ticketname}</div>
              <span style={style}>
                {price > 0 ? currency + " " + price : "FREE"}
              </span>
            </div>

            <div className="action-button vcenter">
              <button
                className="btn btn-default btn-sm btn-delete"
                onClick={this.deleteCallback}
              >
                X
              </button>
            </div>
          </div>
        </td>
      </tr>
    );
  }
}
